import { ReactNode, createContext, useEffect, useState } from "react";
import { getSubGroupsByGroupId } from "../services/SubGroup";
import useGroup from "../hook/useGroup";
import Cookies from "js-cookie";

const SubGroupContext = createContext({});

export const SubGroupProvider = ({ children }: { children: ReactNode }) => {
    const token = Cookies.get("token-my-cdir");
    const { selectedGroupId }: any = useGroup();

    const [allSubGroups, setAllSubGroups] = useState<any[]>([]);
    const [selectedSubGroupId, setSelectedSubGroupId] = useState<number>(0);
    const [refrestTheSubGroup, setRefreshTheSubGroup] = useState<boolean>(true);

    useEffect(() => {
        if (!selectedGroupId) return;

        getSubGroupsByGroupId(selectedGroupId, token!.toString())
            .then(res => {
                const mapped = res?.map((item: any) => ({
                    value: item?.id,
                    label: item?.name
                }));

                setAllSubGroups(mapped);
                setSelectedSubGroupId(0);
                setRefreshTheSubGroup(false);
            })
            .catch(error => {
                console.log(error);
                setSelectedSubGroupId(0);
                setRefreshTheSubGroup(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroupId, refrestTheSubGroup])

    return (
        <SubGroupContext.Provider value={{ allSubGroups, setAllSubGroups, selectedSubGroupId, setSelectedSubGroupId, setRefreshTheSubGroup }}>
            {children}
        </SubGroupContext.Provider>
    )
}

export default SubGroupContext;